import { defineComponent as _defineComponent } from 'vue'
import { marked } from 'marked';
import { computed } from '@nuxtjs/composition-api';
interface Props {
  answer: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FaqAnswer',
  props: {
    answer: null
  },
  setup(__props: any) {

const props = __props as {
  answer: string;
};



const answer = computed(() =>
  props.answer ? marked.parse(props.answer, { mangle: false, headerIds: false }) : null
);

return { __sfc: true,props, answer }
}

})